export default __webpack_public_path__ + "static/media/Board_Level_Committees_2.d4d1572f.pdf";